// The domain constant moved into the `@heidi/runtime/feature-flags` door at
// the F-series (P3): the door's imperative reads default to it, and the app's
// registration sites (`onprem-bundle-provider.tsx`, `_app.tsx`'s
// `<OpenFeatureProvider>`) must stay in lock-step with those reads — one
// source, zero drift. This shim keeps the historical import path alive.
export { FEATURE_FLAG_DOMAIN } from '@heidi/runtime/feature-flags';
